/*********************************************************************
* © Copyright IBM Corp. 2024
*********************************************************************/
import React from 'react'
import {ZIndexProps} from './model'
import {getSimpleCellItemComponent} from './getSimpleCellItemComponent'
import {LogListItem} from '../LogsList'
import {DropdownListFilterHeader} from './DropdownListFilterHeader'
import intl from '../utils/intl/intl'

export interface ServiceHeaderProps extends ZIndexProps {
  service?: string
  servicesOptions?: string[]
  onServiceChange?: (service?: string) => void
}

export const ServiceHeader = ({
  service,
  servicesOptions,
  onServiceChange,
  popoverZIndex
}: ServiceHeaderProps) => {
  const hasOptions = servicesOptions && servicesOptions.length > 0
  const defaultText = hasOptions
    ? intl.formatMessage('All services')
    : intl.formatMessage('Services')

  return (
    <DropdownListFilterHeader
      currentValue={typeof service === 'undefined' ? null : {id: service, displayName: service}}
      defaultValueText={defaultText}
      onCurrentValueChange={selectedValue => onServiceChange && onServiceChange(selectedValue?.id)}
      options={servicesOptions?.map(item => ({id: item, displayName: item})) || []}
      popoverZIndex={popoverZIndex}
    />
  )
}

export const ServiceRow = getSimpleCellItemComponent<LogListItem>(item => item.service)
